import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useIsAuthenticated } from '@azure/msal-react';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const isAuthenticated = useIsAuthenticated();
  const location = useLocation();

  // Prevent deep linking - redirect to apps landing if trying to access directly
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  // Prevent direct access to app routes - must go through apps landing
  if (location.pathname.startsWith('/port-reallocation/')) {
    const hasVisitedApps = sessionStorage.getItem('visited-apps-landing');
    if (!hasVisitedApps) {
      return <Navigate to="/apps" replace />;
    }
  }

  return <>{children}</>;
};

export default ProtectedRoute;
